export const state = {
    auth: null,
    dataList: {},
    formData: {},
    Config: null,
    settings: {},
    showHeader: 1,
    showFooter: 1,
    filters: {},
    isModalOpen: false,
    isLoading: false,
};